import { mapGetters } from 'vuex'

export const computed = {
  ...mapGetters('user', ['currentHoaId', 'currentUnitId', 'currentOwnerId'])
}
